import { render } from "./popuptos.vue?vue&type=template&id=a7484712"
import script from "./popuptos.vue?vue&type=script&lang=js"
export * from "./popuptos.vue?vue&type=script&lang=js"

import "./popuptos.vue?vue&type=style&index=0&id=a7484712&lang=css"
script.render = render

export default script